/**
 * Utility functions for backend flag overrides.
 *
 * These functions allow Perplexity employees to override backend Eppo flag assignments
 * for testing and debugging purposes. Overrides are stored in a cookie and sent to the
 * backend via AskParams.experiment_overrides.
 *
 * IMPORTANT: These overrides only affect BACKEND flag assignments. For frontend React
 * hooks (use*FlagValue), use URL parameters (?eppo_flag=value) instead.
 *
 * FUTURE ENHANCEMENT (Phase 2):
 * - Fetch flag schemas from Eppo REST API (https://eppo.cloud/api/v1/flags)
 * - Validate flag types (boolean, string, number, JSON)
 * - Suggest valid variation names from schema
 * - Provide autocomplete for flag names
 * - Add UI component for schema-based flag builder
 *
 * Current implementation accepts any flag name and infers type from value format.
 * Schema validation will be ADDITIVE - raw string parsing will still work for power users.
 */
import { getCookie, removeCookie, setCookie } from '#pplx/frontend/cookies/provider.js';
const EXPERIMENT_OVERRIDES_COOKIE_KEY = 'pplx_backend_flag_overrides';
const ONE_HOUR_IN_DAYS = 1 / 24;
/**
 * Save experiment overrides to cookie
 */
export const saveExperimentOverrides = (overrides) => {
    if (Object.keys(overrides).length === 0) {
        clearExperimentOverrides();
        return;
    }
    const value = JSON.stringify(overrides);
    setCookie(EXPERIMENT_OVERRIDES_COOKIE_KEY, value, {
        expires: ONE_HOUR_IN_DAYS,
    });
};
/**
 * Load experiment overrides from cookie
 */
export const getExperimentOverrides = () => {
    try {
        const cookieValue = getCookie(EXPERIMENT_OVERRIDES_COOKIE_KEY);
        if (cookieValue) {
            return JSON.parse(cookieValue);
        }
        return {};
    }
    catch {
        return {};
    }
};
/**
 * Clear experiment overrides cookie
 */
export const clearExperimentOverrides = () => {
    removeCookie(EXPERIMENT_OVERRIDES_COOKIE_KEY);
};
//# sourceMappingURL=experimentOverrides.js.map